import React, {useEffect, useState} from 'react';
import {Checkbox, CheckboxProps} from '@mui/material';
import {Main} from 'app/components/entities/cloud';
import {EdgePopover} from 'app/components/widgets/billing';

interface Props extends CheckboxProps {
  billingAccess: boolean;
  capability: Main.CapabilityState;
}

export function EdgeCheckbox({sx, capability, billingAccess, onClick, ...props}: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const active = capability.enabled;

  useEffect(() => {
    if (active) {
      setAnchorEl(null);
    }
  }, [active]);

  return (
    <>
      <Checkbox
        {...props}
        onClick={(e) => {
          if (!active) {
            setAnchorEl(e.currentTarget);
            return;
          }

          onClick?.(e);
        }}
      />

      <EdgePopover
        capability={capability}
        paymentAccess={billingAccess}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
      />
    </>
  );
}
